export default __webpack_public_path__ + "static/media/no-history-data.7d166920.svg";